import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDatasourcesIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			y: 28,
			width: 28,
			height: 28,
			rx: 3,
			transform: "rotate(-90 0 28)",
			fill: "#2371F1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22 7.2H5.60001V10.4H22V7.2ZM8.40001 8H6.80001V9.6H8.40001V8Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22 12.4H5.60001V15.6H22V12.4ZM8.40001 13.2H6.80001V14.8H8.40001V13.2Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22 17.6H5.60001V20.8H22V17.6ZM8.40001 18.4H6.80001V20H8.40001V18.4Z",
			fill: "white"
		})
	]
});
export default SvgDatasourcesIcon;
